import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import './SwingScreener.css';
import { ChartScreenDataProps } from "../model/App";
import { FaArrowLeft } from "react-icons/fa";
import Toast from "./toast/Toast.tsx";
import { ToastContainer, toast } from 'react-toastify';



const SwingScreener = ({ }: ChartScreenDataProps) => {

    const tableData = [
        {
            name: "Advanced Bullish Swing",
            isPremiunContent: true,
        },
        {
            name: "Speed Breaker Swing",
            isPremiunContent: true,
        }
        , {
            name: "100 Simple Moving Average",
        }
        , {
            name: "Trend Bulish",
        }


    ];

    const navigate = useNavigate();

    const handleViewChartList = (obj?: any) => {
        if (obj?.isPremiunContent) {
            notify();
            return;
        }
        navigate('/screener/stocks', { state: { patternName: obj.patternName } })
    }

    const notify = () => toast.info("This is a Premium Screener. Please purchase a plan to access it.", {
        position: "bottom-right",
        autoClose: 5000,
        theme: "dark",
    });

    return (
        <div className="main-content">
            {/* Header */}
            <div className="chart-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <FaArrowLeft />
                </button>
                <h2 className="chart-title">Swing Stock screener</h2>
            </div>
            <div className="table-wrapper-screener table-container-screener">
                <table className="scroll-table-screener">
                    <tbody>
                        {tableData.map((row, i) => (
                            <tr key={i} onClick={() => handleViewChartList(row)}>
                                <td>{row.name} {row.isPremiunContent ? <span style={{ fontSize: "20px", marginRight: "8px" }}>🔒</span> : ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ToastContainer />
        </div>
    );
}

export default SwingScreener;